import React, { useEffect, Fragment } from "react";
import { withRouter } from "react-router-dom";
import { any } from "prop-types";

/* 
  A helper component to wrap around a component to render
  whenever you want react-router to not preserve the scroll state
  Usage example:
    <Route
      path="/onboard/name"
      component={withAuthAndLoading(() => (
        <ScrollToTop>
          <BasicInfoName />
        </ScrollToTop>
        ))}
    />  
*/

const ScrollToTop = ({ history, children }) => {
  useEffect(() => {
    const unlisten = history.listen(() => {
      window.scrollTo(0, 0);
    });
    return () => {
      unlisten();
    };
  }, []);

  return <Fragment>{children}</Fragment>;
};

ScrollToTop.propTypes = {
  history: any,
  children: any,
};

export default withRouter(ScrollToTop);
